import React, { useState } from "react";
import AppRoutes from "routes";
import { authConfig, UserProvider } from "contexts/user";
import { Auth0Provider } from "@auth0/auth0-react";
import CookieBanner, { hasConsented } from "components/CookieBanner";
import { useTranslation } from "react-i18next";
import { BannerProps } from "components/CookieBanner/types";
import TooltipPopup from "components/Tooltip/TooltipPopup";
import { globalStore } from "store/GlobalStore";
import { observer } from "mobx-react-lite";

export default observer(function App() {
  const { t, i18n } = useTranslation();
  const cookieSettings = t("cookieBanner", {
    returnObjects: true,
  }) as BannerProps;

  const [tracking] = useState<string[]>([window.location.href]);

  React.useEffect(() => {
    globalStore.setCurrentLanguage(i18n.language);
  }, []);

  return (
    <Auth0Provider {...authConfig} acr_values={tracking}>
      {hasConsented() ? null : (
        <CookieBanner
          texts={cookieSettings.texts}
          preferences={cookieSettings.preferences}
          onConsent={(allowed, index, name) => {
            if (allowed === false) {
              // using the index as key due to multinlingual names
              localStorage.setItem(`cookie-${index}`, `${name}`);
            }
            // reload the page after consent to allow changes take effect
            window.location.reload();
          }}
        />
      )}
      <UserProvider>
        <AppRoutes />
        <TooltipPopup />
      </UserProvider>
    </Auth0Provider>
  );
});
